import { CognitoUserPool } from "amazon-cognito-identity-js";
import config from "../config";
import AWS from "aws-sdk";
import sigV4Client from "./sigV4Client";
import Amplify, { Auth, Storage } from "aws-amplify"; // Storage configured in index.js

const uuidv4 = require('uuid/v4');

/**********  DEV BUCKET  **********
const stage_bucket = "training-slate-admin-dev-profile-photos";
const identity_pool_id =  'us-west-2:c9d67ee1-ecb3-455d-8ba0-d5567a9e9f6d' //Specify your identityPoolId for Auth and Unauth access to your bucket;

/**********  PROD BUCKET  **********/
////  below stage_bucket only contains profile photos, no document or assessment images/files
const stage_bucket     = "training-slate-admin-prod-profile-photos";
const identity_pool_id = 'us-west-2:0e9ebcd7-1123-413f-bfa9-9b2bc3aae62d' //Specify your identityPoolId for Auth and Unauth access to your bucket;

export async function storageConfigure (bucket) {
    // Specify public bucket //
    Storage.configure({
        bucket: bucket,
        region: 'us-west-2',
        identityPoolId: identity_pool_id
    });
}


export async function s3PublicUpload(bucket_name, file) {
    console.log("Executing s3PublicUpload function...");
    var bucket = stage_bucket;

    if(bucket_name === "messenger_files") {
        bucket = "ts-admin-prod-messenger-files"  // prod //bucket = "ts-admin-dev-messenger-files" // dev
        console.log("Send file to messenger files");
    }

    storageConfigure(bucket);

    const filename = uuidv4();

    const stored = await Storage.put(filename, file, {
            bucket: bucket,
            contentType: file.type
        })
        .then (result => {
            return result.key;
        })
        .catch(err => {
            console.log(err)
        });

    //return stored.key;
    return stored;
}

export async function s3PublicGetImage(bucket_name, photo_id) {
    var bucket = stage_bucket;
    console.log("Get s3PublicGetImage function...");

    if(bucket_name === "messenger_files") {
        bucket = "ts-admin-prod-messenger-files"  // prod - //bucket = "ts-admin-dev-messenger-files" // dev
    } else if(bucket_name === "progress-photos") {
        bucket = "ts-athlete-prod-progress-photos"
    }

    storageConfigure(bucket);

    const photo_url = await Storage.get(photo_id)
        .then (result => {
            return result;
        })
        .catch(err => {
            console.log(err)
        });
    return photo_url;
}

/*******************************************************/
/*************   NO VARS TO CHANGE BELOW   *************/
/*******************************************************/

export async function getS3Attachment (document_id, identityId) {
    console.log("<<<< Get Protected Attachment >>>>");
    var bucket = config.s3.BUCKET;
    storageConfigure(bucket);

    var attachmentURL;

    /*await Storage.vault.get(document_id, {
        level: 'protected',
        identityId: identityId // the identityId of that user
    })
    .then(result => {attachmentURL = result})
    .catch(err => console.log(err));*/
    await Storage.get(document_id, {
        bucket: "training-slate-admin-prod-documents",
        identityId: identityId // the identityId of that user
    })
    .then(result => {attachmentURL = result})
    .catch(err => console.log(err));

    console.log("1. attachmentURL: " + attachmentURL);

    return attachmentURL;
}

export async function s3Upload(file) {
    const filename = uuidv4();//`${Date.now()}-${file.name}`;

    console.log(">>>>>>>>> s3Upload function <<<<<<<<<");
    console.log("filename: " + filename);
    console.log("file.type: " + file.type);
    // Important
    // use Storage.put for public access; this auto-creates a "/public" folder under the bucket root
    // use Storage.vault.put for specific access; this auto-creates a "/private" folder under the bucket root
    var stored;
    /*await Storage.vault.put(filename, file, {
        level: 'protected',
        contentType: file.type
    })
    .then(result => { stored = result; console.log("Successful upload: " + stored)})
    .catch(err => console.log("upload error: " + err));*/
    await Storage.put(filename, file, {
        bucket: "training-slate-admin-prod-documents",
        contentType: file.type
    })
    .then(result => { stored = result; console.log("Successful upload: " + stored)})
    .catch(err => console.log("upload error: " + err));

    return stored.key;
}

export async function s3Delete(document_id) {
    const status = await Storage.vault.remove(document_id)
           .then(result => {
               return true;
           })
           .catch(err => {
               console.log("Err: " + err)
               return null;
           });

    return {status: status};
}

export async function authUser() {
    if(AWS.config.credentials != null) {
        /* console.log("AWS.config.credentials: " + AWS.config.credentials);
        console.log("authUser expireTime: " + AWS.config.credentials.expireTime);
        console.log("Date.now(): "  + Date.now());*/
    }

    if (AWS.config.credentials && Date.now() < AWS.config.credentials.expireTime - 60000) {
        return true;
    }

    const currentUser = getCurrentUser();

    if (currentUser === null) {
      return false;
    }

    const userToken = await getUserToken(currentUser);

    await getAwsCredentials(userToken);

    return true;
}

export async function invokeApig({
      path,
      method = "OPTIONS", /* GET */
      headers = {
          /*"Access-Control-Allow-Origin" : "*",
          "Access-Control-Allow-Credentials" : true,
          "Content-Type": "application/json"*/
      },
      queryParams = {},
      body
    }) {
      if (!await authUser()) {
        throw new Error("AWS Lib: User is not logged in");
      }

      const signedRequest = sigV4Client
            .newClient({
                accessKey: AWS.config.credentials.accessKeyId,
                secretKey: AWS.config.credentials.secretAccessKey,
                sessionToken: AWS.config.credentials.sessionToken,
                region: config.apiGateway.REGION,
                endpoint: config.apiGateway.URL
            })
            .signRequest({
                method,
                path,
                headers,
                queryParams,
                body
            });

      body = body ? JSON.stringify(body) : body;
      headers = signedRequest.headers;

      const results = await fetch(signedRequest.url, {
        method,
        headers,
        body
      });
      //console.log("AWS LIB results.status: " + results.status);

      if (results.status !== 200) {
          console.log("Error in AWSLib");
          // temp remove 8/9:
          // throw new Error(await results.text());
          // console.log("results.text(): " + results.text());

          // Renoved above error code so it doesn't stop the app from working;
          // Specifically used for "duplicating a program" or "sharing a template"
          // After 30 seconds the AWS API gateway times out and returns an error,
          // which is handled here. Each separate Lambda function's timeout must be set, too.
          var results_error = {status: false}
          return results_error;
      }

      return results.json();
}

function getUserToken(currentUser) {
    return new Promise((resolve, reject) => {
        currentUser.getSession(function(err, session) {
            if (err) {
                reject(err);
                return;
            }
            resolve(session.getIdToken().getJwtToken());
        });
    });
}

export function signOutUser() {
    const currentUser = getCurrentUser();

    if (currentUser !== null) {
        currentUser.signOut();
    }

    if (AWS.config.credentials) {
        AWS.config.credentials.clearCachedId();
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({});
    }
}


function getAwsCredentials(userToken) {
    // const authenticator = 'cognito-idp.${config.cognito.REGION}.amazonaws.com/${config.cognito.USER_POOL_ID}';
    // Inexplicably, must use single quotes like below otherwise this CONST isn't valid;
    // i.e. above CONST is not valid
    const authenticator = `cognito-idp.${config.cognito.REGION}.amazonaws.com/${config.cognito.USER_POOL_ID}`;

    AWS.config.update({ region: config.cognito.REGION });

    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
        Logins: {
          [authenticator]: userToken
        }
    });

    return AWS.config.credentials.getPromise();
}

function getCurrentUser() {
    const userPool = new CognitoUserPool({
        UserPoolId: config.cognito.USER_POOL_ID,
        ClientId: config.cognito.APP_CLIENT_ID
    });

    return userPool.getCurrentUser();
}



// WEBPACK FOOTER //
// ./src/libs/awsLib.js